class PostController {
  constructor($location, Post) {
    this.name = 'post';
    this.Post = Post;
    this.$location = $location;
  }
  async $onInit() {
    const { Post, $location } = this;
    this.searchPost = $location.search().title;
    this.searchUser = $location.search().user;
    Post.getAll({ title: this.searchPost, user: this.searchUser }).then((posts) => {
      this.posts = posts;
    });
  }
  onSubmit(title, user) {
    const { $location, Post } = this;
    $location.search({ title, user }).replace();
    Post.getAll({ title, user }).then((posts) => {
      this.posts = posts;
    });
  }
  clearSearch() {
    this.searchPost = '';
    this.searchUser = '';
    this.Post.getAll().then((posts) => {
      this.posts = posts;
    });
  }
}
PostController.$inject = ['$location', 'Post'];

export default PostController;



// WEBPACK FOOTER //
// ./client/app/components/post/post.controller.js